import { useEffect } from "react";
import { useState } from "react";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import PartnersCard from "../PartnersCard";
import { childSettings } from "./settings";

interface SliderChild {
  slide: string[][];
  index: number;
}

const SliderChild: React.FC<SliderChild> = ({ index, slide }) => {
  const [slider, setSlider] = useState<SwiperCore>(null);

  return (
    <Swiper
      {...childSettings}
      onInit={setSlider}
      className="partners__swiper partners__swiper_child"
    >
      {slide.map((icons, id) => (
        <SwiperSlide className="partners__slide partners__slide_child" key={id}>
          <ul className="partners__list">
            {icons.map((icon) => (
              <PartnersCard key={icon}>
                <img src={icon} alt="partner" />
              </PartnersCard>
            ))}
          </ul>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SliderChild;
